var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('base-input-primary-button',{attrs:{"label":"Search","icon":"mdi-magnify"},on:{"click":_vm.search}}),_c('base-input-secondary-button',{attrs:{"label":"Reset","icon":"mdi-close"},on:{"click":_vm.reset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }